angular.module('showcaseApp').directive('quillEditor', ['$translate', function ($translate) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            var hideActions = attrs.hideActions === 'true';
            var withMarkers = attrs.withMarkers === 'true';
            var output = attrs.output || 'html';
            var maxlength = attrs.maxLength ? +attrs.maxLength : null;
            var required = attrs.required === "true";
            var isFocused = false;

            var toolbarOptions = !hideActions ? [
                [{'header': [1, 2, false]}],
                ['bold', 'italic', 'underline', 'strike', 'link'],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'align': []}],
                [{'color': []}, {'background': []}],
            ] : [];

            var quill = new Quill(element[0], {
                theme: 'snow',
                modules: {
                    toolbar: toolbarOptions,
                    keyboard: {}
                }
            });

            scope.$watch(attrs['ngDisabled'], function (newValue) {
                quill.enable(!newValue);
            }, true);

            if (withMarkers) {
                var toolbar = element[0].previousSibling;
                var menuTitle = $translate.instant("campaign.markers.title");
                var nameLabel = $translate.instant("campaign.markers.label.name");
                var nameValue = $translate.instant("campaign.markers.value.name");

                if (toolbar && toolbar.classList.contains('ql-toolbar')) {
                    var customButtonGroup = document.createElement('span');
                    customButtonGroup.className = 'ql-formats';

                    var select = document.createElement('select');
                    select.className = 'ql-marker';

                    select.innerHTML =
                        '<option selected disabled>' + menuTitle + '</option>' +
                        '<option value="{{' + nameValue + '}}">' + nameLabel + '</option>';

                    select.addEventListener('change', function () {
                        var value = this.value;
                        var range = quill.getSelection(true);
                        if (range) {
                            quill.insertText(range.index, value);
                            quill.setSelection(range.index + value.length, 0);
                        }
                        this.selectedIndex = 0;
                    });

                    customButtonGroup.appendChild(select);
                    toolbar.appendChild(customButtonGroup);
                }

                quill.root.addEventListener('keydown', function (e) {
                    if (e.key === '@') {
                        var range = quill.getSelection(true);
                        if (range) {
                            showMarkerDropdown(range.index);
                        }
                    }
                });
            }

            function showMarkerDropdown(index) {
                var container = document.createElement('div');
                container.className = 'marker-suggestion';
                container.innerHTML = '<div class="marker-item" data-value="{{' + nameValue + '}}">' + nameLabel + '</div>';

                var bounds = quill.getBounds(index);
                container.style.left = bounds.left + 'px';
                container.style.top = (bounds.top + 30) + 'px';

                element[0].parentNode.appendChild(container);

                var markerItems = container.querySelectorAll('.marker-item');
                for (var i = 0; i < markerItems.length; i++) {
                    (function (item) {
                        item.addEventListener('click', function () {
                            var marker = item.getAttribute('data-value');
                            var charCurrent = quill.getText(index, 1);

                            if (charCurrent === '@') {
                                quill.deleteText(index, 1);
                            }
                            quill.insertText(index, marker);
                            quill.setSelection(index + marker.length, 0);

                            container.remove();
                        });
                    })(markerItems[i]);
                }

                document.addEventListener('click', function handleOutsideClick(e) {
                    if (!container.contains(e.target)) {
                        container.remove();
                        document.removeEventListener('click', handleOutsideClick);
                    }
                });
            }

            quill.on('text-change', function () {
                if (maxlength && quill.getLength() > maxlength) {
                    quill.deleteText(maxlength - 1, quill.getLength());
                }

                scope.$apply(function () {
                    if (output === 'html') {
                        ngModel.$setViewValue(quill.root.innerHTML);
                    } else {
                        ngModel.$setViewValue(quill.getText());
                    }
                });
            });

            if (required) {
                scope.$apply(function () {
                    ngModel.$setValidity(
                        "required",
                        true
                    );
                });
            }

            window.addEventListener('click', function (e) {
                if (element[0].contains(e.target)) {
                    isFocused = true;
                } else {
                    if (isFocused) {
                        scope.$apply(function () {
                            ngModel.$setTouched();
                        });
                    }
                    isFocused = false;
                }
            });

            ngModel.$render = function () {
                quill.root.innerHTML = ngModel.$viewValue || '';
            };
        }
    };
}]);
